module.exports = __webpack_public_path__ + "img/sparabolle.50fa2fb7.jpg";